
import $ from 'jquery';
import {View} from 'backbone';
import constants from 'Constants';
import _ from 'lodash';
import listService from 'ListService';
import settingsService from 'MandatoryAndStateSettingsService';
import settingsUtil from 'util/SettingsUtil';

// Common settings modal methods lifted here.
class SettingsModalBase extends View {

    initialize( opts ){
        this.isRendered = false;
        this.stages = listService.getWorkflowStages(true).sort(this.sortItems);
        this.roles = listService.getWorkflowRoles(true).sort(this.sortItems);
        this.settings = opts.settings || new Map();
        this.options = opts.options || constants.MANDATORY_OPTIONS;
        this.propertyName = opts.propertyName || 'required';
        this.matrix = [];
        this.rolesArray = [];
    }

    //PF-8770 Sort stages and roles before creating the map
    sortItems(a,b){
        const nameA = a.model ? a.model.get("name").toLowerCase() : a.name.toLowerCase();
        const nameB = b.model ? b.model.get("name").toLowerCase() : b.name.toLowerCase();
        if (nameA < nameB) { return -1; }
        if (nameA > nameB) { return 1; }
        if (nameA === nameB) { return 0; }
    }

    initMap() {

     
        this.stages.forEach((stage) => {
            const newStage = {name: stage.model.get('name'), id: stage.id, settings: []};
            this.roles.forEach(role => {
                const value = this.getValueForSetting(stage.id, role.id);                
                
                const settingsObj = {
                    stageId: stage.id,
                    roleId: role.id,
                    value: value
                };

                newStage.settings.push(settingsObj);
            });
            this.matrix.push(newStage);
        });
    }

    switchRole(e){
        const roleId = e.currentTarget.getAttribute('data-role-id');
        const value = e.currentTarget.value;

        // Reset selection
        $(".switch-role option:selected").prop("selected", false);

        if(roleId && value){

            const inputs = this.getAllInputs();
            const roleInputs = inputs.filter(function(i, e){ return e.getAttribute('data-role-id') === roleId });

            roleInputs.map((index, input) => {
                input.value = value;
            });
        }
    }


    switchStage(e) {
        const stageId = e.currentTarget.getAttribute('data-stage-id');
        const value = e.currentTarget.value;

        // Reset selection
        $(".switch-stage option:selected").prop("selected", false);

        if (stageId && value) {

            const inputs = this.getAllInputs(stageId);
            const roleInputs = inputs.filter(function (i, e) {
                return e.getAttribute('data-stage-id') === stageId
            });

            roleInputs.map((index, input) => {
                input.value = value;
            });
        }
    }

    getAllInputs(stageId=null){
        let $inputs = $('#stagesAndRoles .setting-value');
        if (stageId) {
            $inputs = $inputs.data('stage-id',`'${stageId}'`);
        }
        return $inputs;
    }

    initModel(){
        this.model.set('stages', this.stages, constants.MODEL_SILENT);
        this.model.set('roles', this.roles, constants.MODEL_SILENT);
        this.model.set('isStateChanging', false, constants.MODEL_SILENT);  
        this.model.set('previousStateValue', new Map(this.model.get('state')), constants.MODEL_SILENT); 

    }

    getViewValues(){
        const vvals = _.merge(this.model.toJSON(),
            {matrix: this.matrix, roles: this.roles, options: this.options, title: this.title});
        return vvals;
    }

    addSetting(stageId, roleId, value, altId){
        const newValue = altId || value;

        const
            key =  settingsService.getSettingKey(stageId, roleId),
            setting = settingsService.createSetting(stageId, roleId, this.propertyName, newValue);
        this.settings.set(key, setting);
    }


    // Also a callback used by SettingsUtil.optimizeMatrix
    getValueForSetting(stageId, roleId, settings){
        const
            excludes = settings || {},
            options = {
                stageId: stageId,
                roleId: roleId,
                settings: this.settings,
                defaultValue: this.defaultValue,
                settingsField: this.propertyName,
                excludeIndividual: excludes.excludeIndividual,
                excludeStage: excludes.excludeStage,
                excludeRole: excludes.excludeRole
            };

        return settingsService.getSetting(options);
    }

    saveData(){
        const inputs = $('#stagesAndRoles .setting-value');
        this.settings.clear();
        inputs.map((index, input) => {

            const stageId = input.getAttribute('data-stage-id');
            const roleId = input.getAttribute('data-role-id');
            const newValue = input.value;
            const altId = input.selectedOptions[0].getAttribute('data-altid');

            this.addSetting(stageId, roleId, newValue, altId);
            this.setNewValue( newValue );
        });
        
        const value = this.countValues();
        if(!this.settings.has('all_all')){
            this.addSetting('all', 'all', value);
        }else{
            this.updateSetting('all_all', value);
        }
        
        settingsUtil.optimizeMatrix( this );
        this.triggerUpdate();
        this.model.set('isStateChanging', true);            
    }
    
    updateSetting(key, value){
        let setting = this.settings.get(key);
        setting.required = value;
    }

    countValues(){
        let inividualSettingCounts = {};
        const inputs = $('#stagesAndRoles .setting-value');
        inputs.map((index, input) => {
          inividualSettingCounts[input.value] = isNaN(inividualSettingCounts[input.value]) ? 1 : (inividualSettingCounts[input.value] + 1);
        });
        let sortList = this.sortObject(inividualSettingCounts);
        let maxValue = _.max(sortList, function (o) { return o.value; });
        return maxValue.key;
    }

    sortObject(oldList){
        let newList = [];
        if(oldList.hasOwnProperty('default')){
            newList.push({ key: 'default', value: oldList.default })
        }
        if(oldList.hasOwnProperty('readonly')){
            newList.push({ key: 'readonly', value: oldList.readonly})
        }
        if(oldList.hasOwnProperty('normal')){
            newList.push({ key: 'normal', value: oldList.normal })
        }
        if(oldList.hasOwnProperty('hidden')){
            newList.push({ key: 'hidden', value: oldList.hidden })
        }
        if(oldList.hasOwnProperty('disabled')){
            newList.push({ key: 'disabled', value: oldList.disabled })
        }
        if(oldList.hasOwnProperty('no')){
            newList.push({ key: 'no', value: oldList.no })
        }
        if(oldList.hasOwnProperty('yes')){
            newList.push({ key: 'yes', value: oldList.yes })
        }
        return newList;
    }      
    
    render(){
       
        this.$el.html(this.template(this.getViewValues()));

        const baseHeight = 175;
        const stages = this.stages;
        const additionalHeight = stages.size * 35;

        const baseWidth = 175;
        const roles = this.roles;
        const additionalWidth = roles.size * 100;

        listService.isUndoRedoEnabled = false;

        $( constants.DIALOG_ID ).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: baseHeight + additionalHeight,
            minHeight: baseHeight,
            width: baseWidth + additionalWidth,
            minWidth: baseWidth,
            modal: true,
            resizable: true,
            buttons: [
                {
                    text: 'Ok',
                    'class':'btn-select-item',
                    click: () => {
                        this.saveData();
                        this.closeModal();
                    }
                },

                {
                    'text': 'Cancel',
                    click: () => {
                        this.closeModal();
                    }
                },

                {
                    'text': 'Reset',
                    click: () => {
                        this.reset();
                    }
                }
            ],

            open: () => {
                this.bindEvents();
                $( constants.DIALOG_ID ).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
            },

            close: () => {
                listService.isUndoRedoEnabled = true;
                this.unbindEvents();
            }
        });

        $('div[role="dialog"]').draggable({containment: 'body', scroll: false});

        this.bindEvents();

        // One-shot ESC handler
        ( ctx => {
            ctx.isRendered = true;
            const escHandler = e => {
                // ESCAPE key pressed
                if (e.keyCode === 27) {
                    $(document).off("keydown", escHandler);
                    ctx.closeModal();
                }
            };
            $(document).keydown(escHandler);
        })(this);
    }

    closeModal(){
        listService.isUndoRedoEnabled = true;
        this.unbindEvents();
        if (this.isRendered) {
            this.isRendered = false;
            $(constants.DIALOG_ID).dialog("destroy");
            this.remove();
        }
    }

    bindEvents(){
        $('select.switch-role').change(e =>  this.switchRole(e) );
        $('select.switch-stage').change(e => this.switchStage(e) );
    }

    unbindEvents(){
        $('select.switch-role').off();
        $('select.switch-stage').off();
    }


    reset(){
        const inputs = this.getAllInputs();
        inputs.map((index, input) => input.value = this.defaultValue );
    }

}

export default SettingsModalBase;
